import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import KitoDoctor from '../../../assets/kito-doctor.svg';
import Milestone from './Milestone';
import BaseLayout from '../../../commons/BaseLayout';

import milestones from './milestones';
import styles from './styles.module.css';

function MilestoneCheckerStaticPage() {
  const { t } = useTranslation();
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');
  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar fitHeight >
      <div className={styles.milestoneChecker}>
        <div className={styles.milestoneChecker__header}>
          <img src={KitoDoctor} alt="kito-doctor" />
          <div className={styles.milestoneChecker__header__data}>
            <h3 className={styles.milestoneChecker__header__title}>{t('staticPages.milestoneChecker.title')}</h3>
            <p className={styles.milestoneChecker__header__description}>
              {t('staticPages.milestoneChecker.description')}
            </p>
          </div>
        </div>
        <div className={styles.milestoneChecker__container}>
          {milestones.map((milestone, index) => (
            <Milestone
              id={milestone.id}
              options={milestone.options}
              translateKey={`staticPages.milestoneChecker.ages.age${index}`}
              initiallySelected={index === 0}
              key={milestone.id}
            />
          ))}
        </div>
      </div>
    </BaseLayout>
  );
}

export default MilestoneCheckerStaticPage;
